import { Tooltip } from '@mui/material'
import { TypographyProps } from '@mui/material/Typography'
import TooltipTitleCard from '../styles/TooltipTitleCard.js'

type Variant = TypographyProps['variant']
type TooltipCardsProps = {
  titleCard: string
  classNameCustom: string
  variantCustom?: Variant
}

const TooltipCards = ({ titleCard, classNameCustom, variantCustom = 'inherit' }: TooltipCardsProps) => {
  return (
    <Tooltip title={titleCard} placement="bottom-start" arrow>
      <TooltipTitleCard variant={variantCustom} className={classNameCustom}>
        {titleCard}
      </TooltipTitleCard>
    </Tooltip>
  )
}

export default TooltipCards
